// Required fields for form validation
export const requiredFields = [
  'lastName',
  'firstName',
  'gender',
  'nationality',
  'registered',
  'birthday',
  'primaryContactNumber',
  'email',
  'militaryStatus',
  'currentStatuses',
  'degree',
  'educationStatus',
  'school',
  'major',
  'priority1',
  'certificate',
  'language',
  'expatriate',
  'toWorkDay',
  'activity'
];

// Section navigation config - maps section IDs to their required fields
export const sectionConfig = [
  {
    id: 'section-personal',
    label: '基本資料',
    labelEn: 'Personal',
    fields: ['lastName', 'firstName', 'gender', 'nationality', 'registered', 'birthday', 'primaryContactNumber', 'email'],
  },
  {
    id: 'section-military',
    label: '兵役狀況',
    labelEn: 'Military',
    fields: ['militaryStatus'],
  },
  {
    id: 'section-education',
    label: '學歷資訊',
    labelEn: 'Education',
    fields: ['currentStatuses', 'degree', 'educationStatus', 'school', 'major'],
  },
  {
    id: 'section-job',
    label: '應徵職務',
    labelEn: 'Job',
    fields: ['priority1'],
  },
  {
    id: 'section-language',
    label: '語言能力',
    labelEn: 'Language',
    fields: ['certificate', 'language'],
  },
  {
    id: 'section-work',
    label: '工作意願',
    labelEn: 'Work',
    fields: ['expatriate', 'toWorkDay'],
  },
  {
    id: 'section-activity',
    label: '活動來源',
    labelEn: 'Activity',
    fields: ['activity'],
  },
];

// Initial state for missing fields tracking
export const initializedMissingFields = {
  'lastName': false,
  'firstName': false,
  'gender': false,
  'nationality': false,
  'registered': false,
  'birthday': false,
  'primaryContactNumber': false,
  'email': false,
  'militaryStatus': false,
  'currentStatuses': false,
  'degree': false,
  'educationStatus': false,
  'school': false,
  'major': false,
  'priority1': false,
  'certificate': false,
  'language': false,
  'expatriate': false,
  'toWorkDay': false,
  'activity': false
};
